
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * MessageType enum
 */
class MessageType {
  /**
   * Initialize enum with a given value
   * @param {MessageType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof MessageType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!MessageType}
   * @param {!MessageType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof MessageType)) {
      throw new TypeError('Instance of MessageType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!MessageType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!MessageType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === MessageType.CLIENT.value) {
      return 'CLIENT'
    }
    if (this.value === MessageType.MANAGER.value) {
      return 'MANAGER'
    }
    if (this.value === MessageType.SYSTEM.value) {
      return 'SYSTEM'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!MessageType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!MessageType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!MessageType} Created enum
   */
  static fromObject (other) {
    return new MessageType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
MessageType.CLIENT = new MessageType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
MessageType.MANAGER = new MessageType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
MessageType.SYSTEM = new MessageType(0 + 2)

export { MessageType };

/**
 * Fast Binary Encoding MessageType field model
 */
class FieldModelMessageType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelMessageType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelMessageType}
   * @param {MessageType=} defaults Default value, defaults is new MessageType()
   * @returns {!MessageType} Result value
   */
  get (defaults = new MessageType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new MessageType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelMessageType}
   * @param {!MessageType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelMessageType };
